<template>
  <v-container>
    <h1>{{$t('page.no_found_header')}}</h1>
  </v-container>
</template>

<style scopen lang="scss">
  h1 {
    @include nsb-font-main-header;
    font-size: 40px;
    line-height: 46px;
    margin-top: 80px;
  }
</style>